import { makeAutoObservable } from "mobx";
import { setStorageJwtInfo } from 'utils/commonUtil';
import Cookies from 'js-cookie';

class AuthStore {
  userInfo = null;
  jwt = null ;
  result = [];
  isOpen = false;
  valCondition = {
    memid: "",
    mname: "",
    tel: "",
  };

  constructor() {
    makeAutoObservable(this);
  }

  setUserInfo = (userInfo) => {
    this.userInfo = userInfo;
  };

  setJwtInfo = (jwt) => {
    this.jwt = jwt;
  };

  setResult = (result) => {
    this.result = result;
  };

  setIsOpen = (isOpen) => {
    this.isOpen = isOpen;
  }
  
  setValCondition = (valCondition) => {
    return this.valCondition = {
      ...this.valCondition,
      ...valCondition
    };
  }

  isModalOpen = (isOpen) => {
    this.setIsOpen(isOpen);
  };

  onSetUserInfo = (userInfo) => {
    this.setUserInfo(userInfo);
  };

  onSetJwtInfo = (jwt) => {
    setStorageJwtInfo(jwt);
    this.setJwtInfo(jwt);
  };

  onLogout = () => {
    const allCookies = Cookies.get();
    // 모든 쿠키 삭제
    Object.keys(allCookies).forEach(cookieName => {
      Cookies.remove(cookieName);
    });
    this.setUserInfo(null);
    // this.setJwtInfo(null);
  };

  isCheckUserInfo = () => {
    if(!this.userInfo) {
      const userInfo = Cookies.get('loginInfo');
      userInfo && this.setUserInfo(userInfo);
    }
    return this.userInfo;
  }
  
} // end of class

export default AuthStore;
